import appsettings from "@/store/app-settings";
import { axiosGet, axiosPost } from "@/store/api/axiosUtils.js";
import * as userData from "@/auth/localStorageUtils.js";

const AddDepartUserList = (params) => {
  params.userId = userData.userId()
  return axiosPost(
    appsettings.ocpbComplaintAPIUrl + "api/AssignWorkOrder/AddDepartUserList",
    params
  );
};

const GetDepartUserList = (params) => {
  return axiosGet(
    appsettings.ocpbComplaintAPIUrl + "api/AssignWorkOrder/GetDepartUserList",
    params
  );
};

const GetDepartUserAddList = (params) => {
  return axiosGet(
    appsettings.ocpbComplaintAPIUrl + "api/AssignWorkOrder/GetDepartUserAddList",
    params
  );
};

const SwapUp = (params) => {
  return axiosGet(
    appsettings.ocpbComplaintAPIUrl + "api/AssignWorkOrder/SwapUp",
    params
  );
};

const SwapDown = (params) => {
  return axiosGet(
    appsettings.ocpbComplaintAPIUrl + "api/AssignWorkOrder/SwapDown",
    params
  );
};

const DeleteRow = (params) => {
  return axiosGet(
    appsettings.ocpbComplaintAPIUrl + "api/AssignWorkOrder/DeleteRow",
    params
  );
};

export {
  AddDepartUserList,GetDepartUserList,GetDepartUserAddList,SwapUp,SwapDown,DeleteRow
};
